import { useState } from "react";
import { Select, Button, Space, DatePicker } from "antd";
import trans from "../../../utils";

const { RangePicker } = DatePicker;

export const STATUS_OPTIONS = [
  "open",
  "assigned",
  "pending",
  "inProgress",
  "completed",
  "closed",
  "cancelled",
].map((s) => ({ label: trans(s), value: s }));

const DATE_FILTER_OPTIONS = [
  { label: trans("Today"), value: "today" },
  { label: trans("Yesterday"), value: "yesterday" },
  { label: trans("This Week"), value: "thisWeek" },
  { label: trans("Last Week"), value: "lastWeek" },
  { label: trans("This Month"), value: "thisMonth" },
  { label: trans("Last Month"), value: "lastMonth" },
  { label: trans("Custom Range"), value: "custom" },
];

// Shared Apply/Reset footer every column filter dropdown uses.
function FilterDropdownPanel({ confirm, onApply, onReset, children, width = 220 }) {
  return (
    <div style={{ padding: 12, width }} onKeyDown={(e) => e.stopPropagation()}>
      {children}
      <Space style={{ width: "100%", justifyContent: "flex-end", marginTop: 8 }}>
        <Button
          size="small"
          onClick={() => {
            onReset();
            confirm();
          }}
        >
          {trans("Reset")}
        </Button>
        <Button
          size="small"
          type="primary"
          onClick={() => {
            onApply();
            confirm();
          }}
        >
          {trans("Apply")}
        </Button>
      </Space>
    </div>
  );
}

// Date needs a preset + conditional custom range, which doesn't fit antd's
// native checkbox-list `filters` either — kept as a custom filterDropdown.
export function DateFilterDropdown({ dateFilter, dateFrom, dateTo, onChange, confirm }) {
  const [pendingPreset, setPendingPreset] = useState(dateFilter);
  const [pendingFrom, setPendingFrom] = useState(dateFrom);
  const [pendingTo, setPendingTo] = useState(dateTo);
  return (
    <FilterDropdownPanel
      width={260}
      confirm={confirm}
      onReset={() => onChange({ dateFilter: undefined, dateFrom: undefined, dateTo: undefined })}
      onApply={() => onChange({ dateFilter: pendingPreset, dateFrom: pendingFrom, dateTo: pendingTo })}
    >
      <Select
        allowClear
        style={{ width: "100%" }}
        placeholder={trans("Date")}
        options={DATE_FILTER_OPTIONS}
        value={pendingPreset}
        onChange={(v) => {
          setPendingPreset(v);
          setPendingFrom(undefined);
          setPendingTo(undefined);
        }}
        getPopupContainer={() => document.body}
        dropdownStyle={{ zIndex: 2000 }}
      />
      {pendingPreset === "custom" && (
        <RangePicker
          style={{ width: "100%", marginTop: 8 }}
          onChange={(range) => {
            setPendingFrom(range?.[0]?.format("YYYY-MM-DD"));
            setPendingTo(range?.[1]?.format("YYYY-MM-DD"));
          }}
          getPopupContainer={() => document.body}
          popupStyle={{ zIndex: 2000 }}
        />
      )}
    </FilterDropdownPanel>
  );
}
